(function () {
    'use strict';

    var filterRoot = document.querySelector('[data-filter-root]');
    var feed = document.querySelector('[data-content-feed]');
    var emptyMsg = document.querySelector('[data-feed-empty]');
    if (!filterRoot || !feed) return;

    var typeButtons = [].slice.call(document.querySelectorAll('[data-filter-type]'));
    var tagButtons = [].slice.call(document.querySelectorAll('[data-filter-tag]'));
    var currentType = 'all';
    var currentTag = 'all';

    function getCards() {
        return [].slice.call(feed.querySelectorAll('[data-content-card]'));
    }

    function readURL() {
        var p = new URLSearchParams(window.location.search);
        var t = p.get('type');
        var g = p.get('tag');
        if (t && typeButtons.some(function (b) { return b.getAttribute('data-filter-type') === t; })) {
            currentType = t;
        }
        if (g && tagButtons.some(function (b) { return b.getAttribute('data-filter-tag') === g; })) {
            currentTag = g;
        }
    }

    function writeURL() {
        var p = new URLSearchParams(window.location.search);
        if (currentType === 'all') { p.delete('type'); } else { p.set('type', currentType); }
        if (currentTag === 'all') { p.delete('tag'); } else { p.set('tag', currentTag); }
        var q = p.toString();
        history.replaceState({}, '', location.pathname + (q ? '?' + q : '') + location.hash);
    }

    function applyFilters(sync) {
        var cards = getCards();
        var visible = 0;

        cards.forEach(function (card) {
            var type = card.getAttribute('data-content-type') || 'blog';
            var tags = (card.getAttribute('data-content-tags') || '').split(',').filter(Boolean);
            var show = (currentType === 'all' || type === currentType)
                && (currentTag === 'all' || tags.indexOf(currentTag) !== -1);
            card.hidden = !show;
            card.style.display = show ? '' : 'none';
            if (show) visible++;
        });

        if (emptyMsg) emptyMsg.hidden = visible > 0;

        // Update button states
        typeButtons.forEach(function (b) {
            var active = b.getAttribute('data-filter-type') === currentType;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-pressed', String(active));
        });
        tagButtons.forEach(function (b) {
            var active = b.getAttribute('data-filter-tag') === currentTag;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-pressed', String(active));
        });

        if (sync) writeURL();
    }

    typeButtons.forEach(function (b) {
        b.addEventListener('click', function () {
            currentType = b.getAttribute('data-filter-type') || 'all';
            applyFilters(true);
        });
    });

    tagButtons.forEach(function (b) {
        b.addEventListener('click', function () {
            currentTag = b.getAttribute('data-filter-tag') || 'all';
            applyFilters(true);
        });
    });

    // Watch for dynamically added cards (pagination, etc.)
    if (window.MutationObserver) {
        new MutationObserver(function () { applyFilters(false); })
            .observe(feed, { childList: true });
    }

    readURL();
    applyFilters(false);
})();
